import useIsDesktop from 'hooks/useIsDesktop';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Toast from 'react-native-toast-notifications';
import { ToastProps } from 'react-native-toast-notifications/lib/typescript/toast';
import { isAndroid, isIos, isWeb } from 'utils/deviceUtils';
import CustomToast, { toastDuration } from '../components/common/CustomToast';

const offsetTop = () => {
  if (isIos) {
    return 40;
  }
  return isAndroid ? 20 : 90;
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    elevation: 9999, // For Android
    pointerEvents: 'box-none', // Allow touches to pass through to elements beneath
  },
});

const CustomToastProvider: React.FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={styles.container}
      accessibilityViewIsModal={false}
      importantForAccessibility="yes">
      <Toast
        ref={(ref) => (global.toast = ref)}
        renderToast={(toastOptions: ToastProps) => CustomToast(toastOptions)}
        animationType="slide-in"
        placement={isWeb && !isDesktop ? 'bottom' : 'top'}
        duration={toastDuration.displayTime}
        animationDuration={toastDuration.animationTime}
        offsetTop={offsetTop()}
        // Increase priority of toast messages
        swipeEnabled={true}
      />
    </View>
  );
};

export default CustomToastProvider;
